<script setup lang="ts">
import { computed } from 'vue';
import { useAuthentication, useUserContext } from '@ilteducation/ilt-auth';
import { useLocale } from '@/plugins/translation';
import config from '../config/ConfigProvider';

const logoImageFile = config.value('logoImageFile');

const homeUrl = config.value('homeUrl');
const serviceName = config.value('serviceName');

const { t, l } = useLocale();
const { createLogoutLink } = useAuthentication();

const logoImage = computed(() => new URL(`/src/assets/images/${logoImageFile}`, import.meta.url).href);

const onClick = async () => {
  await useUserContext().logout();
  window.location.href = createLogoutLink(window.location.origin);
};
</script>

<template>
  <v-container fluid flex class="text-center">
    <v-row class="row--fullsize mt-9" justify="center">
      <v-col xs="12" md="5" lg="3">
        <v-img :src="logoImage" max-height="60px" :alt="serviceName + ' logo'"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-secondary">
        <h1>{{ t(l.no_access.title) }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-secondary">
        <a :href="homeUrl">{{ t(l.no_access.text) }} </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="button-log-out-user" color="secondary" @click="onClick">{{ t(l.no_access.button) }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
a {
  text-decoration: underline;
}

.button-log-out-user {
  letter-spacing: normal;
  font-size: 0.875rem;
  border-radius: 4px;
}
</style>
